<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('employees')" :icon="'grid'" />
            </div>
            <div 
                class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('store_employees')"
            >
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ this.$t('new-employee') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <employee-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="employee-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';
import AppFunction from '../../../../core/helpers/app/AppFunction';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppEmployees",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'employees-table',
            rowData: {},
            options: {
                name: 'AppEmployees',
                url: actions.EMPLOYEE,
                showHeader: true,
                tableShadow: false,
                enableHighlights: true,
                enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('#'),
                        type: 'text',
                        key: 'id',
                    },
                    {
                        title: this.$t('Photo'),
                        type: 'media-object',
                        key: 'photo',
                        mediaTitleKey: '',
                        mediaSubtitleKey: '',
                        default: AppFunction.getAppUrl('images/avatar-demo.jpg'),
                        modifier: (value, row) => {
                            return value; // imag url
                        },
                        isVisible: true
                    },
                    {
                        title: this.$t('name'),
                        type: 'custom-html',
                        modifier: (value, row) => {
                            return `<span>${row.last_name} ${row.middle_name} ${row.first_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        modifier: (value, row) => {
                            if(value == 'active') {
                                return `<span class="badge rounded-pill badge-success">${this.$t(value)}</span>`;
                            } else if (value == 'suspended') {
                                return `<span class="badge rounded-pill badge-warning">${this.$t(value)}</span>`;
                            } else {
                                return `<span class="badge rounded-pill badge-danger">${this.$t(value)}</span>`
                            }
                        }
                    },
                    {
                        title: this.$t('matricule'),
                        type: 'text',
                        key: 'matricule',
                    },
                    {
                        title: this.$t('email'),
                        type: 'text',
                        key: 'email',
                    },
                    {
                        title: this.$t('phone'),
                        type: 'text',
                        key: 'phone',
                    },
                    
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'employee-add-modal',
                        modalId: 'employee-add-edit-modal',
                        modifier: () => this.$can('update_employees'),

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                        modifier: () => this.$can('delete_employees'),
                    }
                ],
                filters: [
                    {
                        "title": this.$t('created_at'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                showFilter: true,
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal 
         */
        closeAddEditModal() {
            $("#employee-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;

            if (actionObj.title == this.$t('delete')) {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.EMPLOYEE}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.EMPLOYEE}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#employee-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
